var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgVolumeUpFilled = function SvgVolumeUpFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.875 8.625H3.5a1 1 0 0 0-1 1v4.75a1 1 0 0 0 1 1h2.375l3.979 3.371a1 1 0 0 0 1.646-.763V6.017c0-.852-.997-1.314-1.646-.763L5.875 8.625Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.537 15.978c1.162-.722 1.963-2.224 1.963-3.973 0-1.749-.801-3.252-1.963-3.983M18.505 19.065c1.808-1.555 2.995-4.135 2.995-7.062 0-2.931-1.189-5.513-3-7.067"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVolumeUpFilled);
export default ForwardRef;